import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatSnackBarModule } from '@angular/material/snack-bar';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { AppEffects } from './app.effects';
import { reducer, initialState } from './app.reducer';
import { getEnvironment } from '../../features/shared/utils/get-environment';
import { createLocalStorageSyncReducer } from '../local-storage-sync';
import { AppState } from './app.state';

const syncMetaReducer = createLocalStorageSyncReducer<AppState>({
  keys: ['sidenavExtended'],
  rehydrate: true,
  storage: sessionStorage,
  storageKeySerializer: (key) => `semeris-${getEnvironment()}-${key}`,
});

@NgModule({
  imports: [
    CommonModule,
    MatSnackBarModule,
    StoreModule.forFeature('app', reducer, { initialState, metaReducers: [syncMetaReducer] }),
    EffectsModule.forFeature([AppEffects]),
  ],
  providers: [AppEffects],
})
export class AppStoreModule {}
